import "../../styles/components/common/buttonElementComponent.css";

export const ButtonElementComponent = ({ buttonElementProps }) => {
  const { label, onClick, type, className, disabled, style, removeDefaultStyle } = buttonElementProps;

  return (
    <button type={type || "button"} onClick={onClick} className={`${removeDefaultStyle ? "" : "buttonContainer"} ${className}`} disabled={disabled} style={style}>
      {label}
    </button>
  );
};

export default ButtonElementComponent;
